import { DzbFieldTypes } from 'dzb/inquiry/fields';
import { StepSequence } from 'new/form/model';

export const dzbStepSequence: StepSequence<DzbFieldTypes> = [
  'companyDataPage',
  'retailerDataPage',
  'personalDataPage',
];
